import PropTypes from 'prop-types';
import React from 'react';
import {
  SUBMITTING_UPDATE_EMPLOYEE,
  SUBMITTING_CREATE_EMPLOYEE,
} from 'actions/employees/staff/constants';
import withFeatureFlags from 'hocs/withFeatureFlags';
import StaffForm from './StaffForm';
import AssignOutletModal from './AssignOutletModal';
import styles from './StaffDetail.css';
import EmployeeDeleteModal from './EmployeeDeleteModal';
import DeactivateStaffModal from './DeactivateStaffModal';
import StopRenewalModal from './StopRenewalModal';

class StaffDetail extends React.Component {
  render() {
    const {
      outlets,
      showAssignOutletModal,
      showEmployeeDeleteModal,
      employeeDetail,
      roles,
      formValues,
      onCancelDeleteEmployee,
      onConfirmDeleteEmployee,
      onClickDeleteEmployee,
      submitting,
      searchFormValues,
      onClickDeactivateEmployee,
      onCancelDeactivateEmployee,
      onConfirmDeactivateEmployee,
      showDeactivateStaffModal,
      slotDetail,
      onClickReactivate,
      deactivateDisabled,
      onClickStopRenewal,
      showLinkStopRenewal,
      showStopRenewalModal,
      onCancelStopRenewal,
      onProceedStopRenewal,
      showDeactivateEmployeeErrorMessage,
      pinAccessImprovement,
      employeePins,
    } = this.props;
    return (
      <div className={styles.wrapper}>
        <StaffForm
          outlets={outlets}
          roles={roles}
          onClickAssignOutlet={this.props.onClickFormAssignOutlet}
          employee={employeeDetail}
          onSubmit={this.props.onSubmit}
          formValues={this.props.formValues}
          onClickDeleteEmployee={onClickDeleteEmployee}
          selfView={this.props.selfView}
          disableSubmit={
            submitting === SUBMITTING_UPDATE_EMPLOYEE ||
            submitting === SUBMITTING_CREATE_EMPLOYEE
          }
          searchFormValues={searchFormValues}
          onClickDeactivateEmployee={onClickDeactivateEmployee}
          slot={slotDetail}
          onClickReactivate={onClickReactivate}
          deactivateDisabled={deactivateDisabled}
          onClickStopRenewal={onClickStopRenewal}
          showLinkStopRenewal={showLinkStopRenewal}
          employeePins={pinAccessImprovement ? employeePins : ''}
        />
        <AssignOutletModal
          show={showAssignOutletModal}
          outlets={outlets}
          onClickCancel={this.props.onClickCancelAssignOutletModal}
          onClickAssign={this.props.onClickConfirmAssignOutletModal}
          assignedOutletIds={formValues.outlets}
        />
        {employeeDetail && (
          <EmployeeDeleteModal
            show={showEmployeeDeleteModal}
            onCancel={onCancelDeleteEmployee}
            onDelete={onConfirmDeleteEmployee}
            employee={employeeDetail}
          />
        )}
        <DeactivateStaffModal
          show={showDeactivateStaffModal}
          onCancel={onCancelDeactivateEmployee}
          onDeactivate={onConfirmDeactivateEmployee}
          employeeDetail={employeeDetail}
          errorMessage={showDeactivateEmployeeErrorMessage}
        />
        {searchFormValues && searchFormValues.status === 'active' && (
          <StopRenewalModal
            show={showStopRenewalModal}
            onCancel={onCancelStopRenewal}
            onProceed={onProceedStopRenewal}
            slot={slotDetail}
          />
        )}
      </div>
    );
  }
}

StaffDetail.propTypes = {
  outlets: PropTypes.array,
  onClickDeleteEmployee: PropTypes.func,
  onConfirmDeleteEmployee: PropTypes.func,
  onCancelDeleteEmployee: PropTypes.func,
  onClickCancelAssignOutletModal: PropTypes.func,
  onClickConfirmAssignOutletModal: PropTypes.func,
  onClickFormAssignOutlet: PropTypes.func,
  onSubmit: PropTypes.func,
  showAssignOutletModal: PropTypes.bool,
  showEmployeeDeleteModal: PropTypes.bool,
  employeeDetail: PropTypes.object,
  formValues: PropTypes.object,
  submitting: PropTypes.string,
  searchFormValues: PropTypes.object,
  onClickDeactivateEmployee: PropTypes.func,
  onConfirmDeactivateEmployee: PropTypes.func,
  onCancelDeactivateEmployee: PropTypes.func,
  showEmployeeDeactivateModal: PropTypes.bool,
  slotDetail: PropTypes.object,
  onClickReactivate: PropTypes.func,
  deactivateDisabled: PropTypes.bool,
  onClickStopRenewal: PropTypes.func,
  showLinkStopRenewal: PropTypes.bool,
  showStopRenewalModal: PropTypes.bool,
  onCancelStopRenewal: PropTypes.func,
  onProceedStopRenewal: PropTypes.func,
  employeePins: PropTypes.array,
};

const mapFlagsToProps = flags => {
  return {
    pinAccessImprovement: flags.pinAccessImprovement,
  };
};

export default withFeatureFlags(mapFlagsToProps)(StaffDetail);
